<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="fromThirdParty" ref="fromThirdParty" class="demo-form-inline" @submit.native.prevent>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-form-item :label="$t('pgCommon.PROPERTY_NAME')" prop="caption">
                            <td-input v-model="fromThirdParty.caption"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsView" :loading="loading" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddThirdConfig">{{ $t('pgCommon.ADD') }}</td-button>
                    <td-button type="button" :permissions="permissionsSync" @click="btnBatchSync" :loading="syncLoading">{{ $t('pgCommon.BATCH_SYNC') }}</td-button>
                    <td-button type="button" :permissions="permissionsDel" @click="btnBatchDelete" :loading="batchDeleteLoading">{{ $t('pgCommon.DELETE_BATCH') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <td-permission :permissions="permissionsView" style="display:auto;">
                <div slot="havePermission">
                    <!-- 加载表格 -->
                    <td-table
                        :columns="columns"
                        :dataSource="tableData"
                        :pageSize="pageSize"
                        :currentPage="currentPage"
                        :total="total"
                        :rowKey="sId"
                        @handleSizeChange="handleSizeChange"
                        @currentChange="currentChange"
                        ref="tdTable"
                    ></td-table>
                    <!-- 加载dialog -->
                    <dialog-ThirdInfo
                        v-if="dialogVisible"
                        :isAddData="isAddData"
                        :dialogVisible="dialogVisible"
                        :editItem="editItem"
                        :title="title"
                        @dbDialogClose="dbDialogClose"
                        @btnQuery="btnQuery"
                    ></dialog-ThirdInfo>
                </div>
            </td-permission>
        </el-main>
    </el-container>
</template>
<script>
import thirdPartyApi from './assets/api.js';
import dialogThirdInfo from './components/dialogThirdConfigInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-ThirdInfo': dialogThirdInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.listQuery();
    },
    // 定义数据
    data() {
        return {
            permissionsView: ['configUrl:view'],
            permissionsAdd: ['configUrl:add'],
            permissionsDel: ['configUrl:del'],
            permissionsEdit: ['configUrl:edit'],
            permissionsSync: ['configUrl:sync'],
            fromThirdParty: { caption: '' },
            editItem: '',
            dialogVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            batchDeleteLoading: false, // 批量删除按钮是否为加载状态
            syncLoading: false, //批量同步按钮是否为加载状态
            columns: [
                {
                    prop: 'sDescription',
                    label: 'pgCommon.PROPERTY_NAME'
                },
                {
                    prop: 'sKey',
                    label: 'pgCommon.PRIMARY_KEY'
                },
                {
                    prop: 'sUrl',
                    label: 'pgCommon.METHOD_URL',
                    showOverflowTooltip: true
                },
                {
                    prop: 'sValue',
                    label: 'pgCommon.VALUE',
                    showOverflowTooltip: true
                },
                {
                    prop: 'iMode',
                    label: 'pgCommon.QUEST_TYPE',
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.iMode === 0) {
                            return createElement('span', this.$t('pgCommon.QUEST_TYPE_POST'));
                        }
                        return createElement('span', this.$t('pgCommon.QUEST_TYPE_GET'));
                    }
                },
                {
                    prop: '',
                    label: 'pgCommon.OPERATE',
                    tableWidth: '120',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsSync, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnSync(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.SYNCHRONIZE')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delete(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.listQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.listQuery();
        },
        // 查询按钮
        btnQuery() {
            this.currentPage = 1;
            this.listQuery();
        },
        // 查询数据
        listQuery() {
            this.loading = true;
            var param = {
                description: this.fromThirdParty.caption,
                isPage: true,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            thirdPartyApi.queryConfigThirdParty(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('thirdPartyController/queryConfigThirdParty', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('thirdPartyController/queryConfigThirdParty', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddThirdConfig() {
            this.title = 'pgCommon.THIRD_CONFIG_ADD'; // 标题
            this.isAddData = true;
            this.dialogVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = 'pgCommon.THIRD_CONFIG_EDIT';
            this.isAddData = false;
            this.dialogVisible = true;
        },
        // 删除
        delete(row) {
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: window.vue.$t('pgCommon.SURE'),
                cancelButtonText: window.vue.$t('pgCommon.CANCEL'),
                type: 'warning'
            }).then(() => {
                let param = this.getDeleteParam(row);
                thirdPartyApi.deleteConfigThirdParty(JSON.stringify(param), response => {
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        return;
                    }
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('setting/thirdPartyController/deleteConfigThirdParty', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                    this.btnQuery();
                });
            });
        },
        // 批量删除
        btnBatchDelete() {
            this.batchDeleteLoading = true;
            let items = this.$refs.tdTable.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                this.batchDeleteLoading = false;
                return;
            }
            this.$confirm(this.$t('pgCommon.DELETE_INFO_TIPS'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = this.getDeleteParam();
                    thirdPartyApi.deleteConfigThirdParty(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.batchDeleteLoading = false;
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('setting/thirdPartyController/deleteConfigThirdParty', response.data.statusMessage);
                            this.batchDeleteLoading = false;
                            return;
                        }
                        this.batchDeleteLoading = false;
                        this.$message({ showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS'), type: 'success' });
                        this.btnQuery();
                    });
                })
                .catch(() => {
                    this.batchDeleteLoading = false;
                });
        },
        // 获取删除参数
        getDeleteParam(row) {
            let deleteParam = {
                recordIdList: []
            };
            if (this.$util.isEmpty(row)) {
                // 批量删除
                let items = this.$refs.tdTable.getSelectAllRows();
                for (let i = 0; i < items.length; i++) {
                    deleteParam.recordIdList.push(items[i].sId);
                }
            } else {
                // 单个删除
                deleteParam.recordIdList.push(row.sId);
            }
            return deleteParam;
        },
        // 获取同步参数
        getSyncParam(row) {
            let syncParam = {
                settingUrlList: []
            };
            if (this.$util.isEmpty(row)) {
                // 批量同步
                let items = this.$refs.tdTable.getSelectAllRows();
                for (let i = 0; i < items.length; i++) {
                    syncParam.settingUrlList.push(items[i]);
                }
            } else {
                // 单个同步
                syncParam.settingUrlList.push(row);
            }
            return syncParam;
        },
        // 批量同步
        btnBatchSync() {
            this.syncLoading = true;
            let items = this.$refs.tdTable.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                this.syncLoading = false;
                return;
            }
            this.$confirm(this.$t('pgCommon.SYNC_TACK_LONG_TIME_CONFIRM_CONTINUE'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SURE'),
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = this.getSyncParam();
                    thirdPartyApi.syncThirdPartyConfig(JSON.stringify(param), response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.syncLoading = false;
                            return;
                        }

                        if (response.data.statusCode == this.$t('pgCommon.SYNC_FAIL_EXIST_CODE')) {
                            this.$message({
                                showClose: true,
                                message: this.$t('pgCommon.SYNC_SUCCESS_NUM') + response.data.count + '，' + response.data.statusMessage + response.data.content,
                                type: 'warning'
                            });
                        } else if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('setting/thirdPartyController/syncThirdPartyConfig', response.data.statusMessage);
                            this.syncLoading = false;
                            return;
                        } else {
                            this.$message({ showClose: true, message: this.$t('pgCommon.SYNC_SUCCESS'), type: 'success' });
                        }
                        this.syncLoading = false;

                        this.btnQuery();
                    });
                })
                .catch(() => {
                    this.syncLoading = false;
                });
        },
        // 同步
        btnSync(item) {
            if (this.$util.isEmpty(item)) {
                return;
            }
            let param = this.getSyncParam(item);
            thirdPartyApi.syncThirdPartyConfig(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode == this.$t('pgCommon.SYNC_FAIL_EXIST_CODE')) {
                    this.$message({
                        showClose: true,
                        message: this.$t('pgCommon.SYNC_FAIL'),
                        type: 'error'
                    });
                } else if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('setting/thirdPartyController/syncThirdPartyConfig', response.data.statusMessage);
                    return;
                } else {
                    this.$message({ showClose: true, message: this.$t('pgCommon.SYNC_SUCCESS'), type: 'success' });
                }
            });
        },
        // 关闭页面
        dbDialogClose() {
            this.dialogVisible = false;
        }
    }
};
</script>
<style></style>
